import React from 'react'
import { TStepProps, TValidator } from '@health-zelas/quiz'
import { TextInput, Radio, RequiredField } from '@packages/components'
import { Paragraph } from '@health-zelas/delta'

import { QuestionHeader } from '../../../components/QuestionHeader'
import { OptInGroup } from '../../../components/OptInGroup'

import { BaseLayout } from '../../../layouts/BaseLayout'

import { cpfMask, phoneMask } from '../../../utils/masks'
import { isCpfValid } from '../../../utils/isCpfValid'
import { isEmailValid } from '../../../utils/isEmailValid'
import { isPhoneValid } from '../../../utils/isPhoneValid'

import * as S from './IndividualDetailedContact.styles'

export function IndividualDetailedContact({ ProgressBar, Navigation }: TStepProps){
  return (
    <BaseLayout navigation={Navigation} progressBar={ProgressBar}>
      <QuestionHeader
        title="Por último, informe seu contato."
        description='Um dos nossos especialistas entrará em contato com uma cotação personalizada.'
      />

      <S.FieldGroup>
        <TextInput
          label="Nome"
          name="firstname"
          id="firstname"
          required
          validator={RequiredField}
        />

        <TextInput
          label="Sobrenome"
          name="lastname"
          id="lastname"
          required
          validator={RequiredField}
        />

        <TextInput
          label="E-mail"
          name="email"
          id="email"
          required
          validator={{
            func: (fieldValue = '') => isEmailValid(fieldValue),
            msg: (fieldValue = '') => {
              if (!fieldValue.trim()) {
                return 'Campo obrigatório'
              }

              return 'E-mail inváldo'
            }
          } as TValidator}
        />

        <TextInput
          label="Telefone com DDD"
          name="phone"
          id="phone"
          mask={phoneMask}
          required
          validator={{
            func: (fieldValue = '') => isPhoneValid(fieldValue),
            msg: (fieldValue = '') => {
              if (!fieldValue.trim()) {
                return 'Campo obrigatório'
              }

              return 'Telefone inváldo'
            }
          } as TValidator}
        />

        <TextInput
          label="CPF"
          name="cpf"
          id="cpf"
          mask={cpfMask}
          required
          validator={{
            func: (fieldValue = '') => isCpfValid(fieldValue),
            msg: (fieldValue = '') => {
              if (!fieldValue.trim()) {
                return 'Campo obrigatório'
              }

              return 'CPF inváldo'
            }
          } as TValidator}
        />
      </S.FieldGroup>

      <Paragraph>Como prefere finalizar sua cotação?</Paragraph>

      <Radio
        name="communication_channel"
        validator={RequiredField}
        options={[
          {
            value: 'Whatsapp',
            label: 'WhatsApp',
            id: 'whatsapp'
          },
          {
            value: 'Telefone',
            label: 'Ligação',
            id: 'call'
          }
        ]}
        required
        css={{ marginBottom: '$xs' }}
      />

      <OptInGroup />
    </BaseLayout>
  )
}
